import _ from 'lodash'
import client, {post} from '@/base-http'
import { Page } from '@/modules/cms/types'
import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Obtiene una página
 *
 * @param id
 */
export const getPage = async (id: number) => {
    const response = await client.get(`/seo/pages/${id}`)

    return Page.deserialize(response.data)
}

/**
 * Obtiene del servidor la lista de todas las páginas registradas en el sitio
 */
export const listPages = async () => {
    const response = await client.get('/seo/pages')
    const pages: object[] = response.data

    if (!Array.isArray(pages)) {
        throw new Error('Se esperaba un array con las paginas SEO pero se obtuvo otro valor')
    }

    return pages.map(page => Page.deserialize(page))
}

/**
 * Sincroniza la lista de páginas con las rutas en el sistema marcadas como
 * páginas
 *
 * @returns {Promise<Page[]>}
 */
export const syncPageRouteMap = async (): Promise<Page[]> => {
    const response = await client.put('seo/pages/mapping', {})

    return response.data.map((p: KeyValuePair) => Page.deserialize(p))
}

/**
 * Actualiza una página en el servidor
 *
 * @param page
 */
export const updatePage = async (page: Page) => {
    const p = page.serialize()
    const response = await client.put(`seo/pages/${page.id}`, p)

    return Page.deserialize(response.data)
}

/**
 * Crea una nueva página en el servidor
 *
 * @param page { Page }
 */
export async function createPage (page: Page) {
    const response = await client.post('seo/pages', page.serialize())

    return Page.deserialize(response.data)
}

/**
 * Elimina una página del servidor
 *
 * @param id { number }
 */
export async function deletePage (id: number) {
    const response = await client.delete(`seo/pages/${id}`)

    return response.data.success || false
}

export async function generatePagePreview (page: Page): Promise<string> {
    try {
        return (await post('seo/page/preview', page.serialize())).preview_data
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}
